import styles from "./Terms.module.scss";

interface Props {
  /* Let's describe props here */
}

export const Terms: React.FC<Props> = () => {
  return <div className={styles.root}>a Terms component</div>;
};
